import "@/assets/styles/premium-table.css";
import "@/assets/styles/premium-table-loading.css";
import "@/assets/styles/premium-dialog.css";
import "@/assets/styles/premium-fullscreen-dialog.css";
import "@/assets/styles/premium-action-menu.css";
import "@/assets/styles/premium-form-fields.css";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
import { createApp } from "vue";
import VueApexCharts from "vue3-apexcharts";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { ProgressiveModuleLoad } from "./mixins/Extras/ProgressiveModuleLoad.js";
import PremiumTableLoading from "./components/Extras/PremiumTableLoading.vue";
import { registerAuthHubListener } from "./services/authHub.js";
import { getAwsConfig } from "./aws-config.js";

loadFonts();
const awsConfig = getAwsConfig();

Amplify.configure({
  Auth: {
    Cognito: {
      region: "ap-south-1",
      userPoolId: awsConfig.userPoolId,
      userPoolClientId: awsConfig.userPoolClientId,
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: awsConfig.appsyncEndpoint,
      region: "ap-south-1",
      defaultAuthMode: "userPool",
    },
  },
}, {
  API: {
    GraphQL: {
      // Amplify v6's default "userPool" authMode sends the ACCESS token,
      // which carries no "email" claim - but every AppSync resolver here
      // derives the caller's identity server-side via
      // $context.identity.claims.get("email"). Force the ID token (which
      // does carry email) instead, or every caller-identity check fails.
      headers: async () => {
        const session = await fetchAuthSession();
        return {
          Authorization: session.tokens?.idToken?.toString() || "",
        };
      },
    },
  },
});

registerAuthHubListener();

createApp(App)
  .use(store)
  .use(router)
  .mixin(ProgressiveModuleLoad)
  .component("PremiumTableLoading", PremiumTableLoading)
  .use(vuetify)
  .use(VueApexCharts)
  .use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAP_KEY_VOZCARE_PORTAL,
      libraries: "places",
    },
  })
  .mount("#app");
